import { Big } from 'big.js';
import { isString } from 'lodash';
import moment from 'moment';
import DateFormats from 'constants/DateFormats';

export function splitIntoTriplets(n) {
  return (n + '')
    .split('')
    .reverse()
    .join('')
    .replace(/(\d{3})/g, '$1 ')
    .split('')
    .reverse()
    .join('')
    .trim();
}

export function toFixed(n, d) {
  return +n.toFixed(d);
}

export function humanize_old(d) {
  return splitIntoTriplets(toFixed(d, 2)).replace('.', ',');
}

export function toRequiredLabel(label) {
  let requiredLabel = label;

  if (label.charAt(label.length - 1) !== '*') {
    requiredLabel = `${requiredLabel} *`;
  }

  return requiredLabel;
}

export function toFixedLeft(num, n = 2) {
  const length = ('' + num).length;
  if (length >= n) {
    return num;
  }

  return new Array(n - length).fill(0).join('') + num;
}

export function humanizeRub(d) {
  return splitIntoTriplets((+d).toFixed(2));
}

export function humanize(d) {
  return splitIntoTriplets((+d).toFixed(2));
}

export function humanizeWithoutFixed(d = '') {
  d = d === null ? '' : d;
  let string = !isString(d) ? d.toString() : d;
  const isNumber = !isNaN(+string);
  if (~string.indexOf(',')) {
    string = string.replace(',', '.');
  }
  if (~string.indexOf('.') && isNumber) {
    const chunks = string.split('.');
    return `${splitIntoTriplets(chunks[0])}.${chunks[1]}`;
  }
  if (isNumber) {
    return splitIntoTriplets(+d);
  } else {
    return d;
  }
}

export function humanizeBig(d, fixTo = 2) {
  return splitIntoTriplets(new Big(d).toFixed(fixTo));
}

export function formatAddress(address) {
  if (!address) return '—';
  address = address.replace(/,+/g, ', ');

  if (address[address.length - 2] === ',') {
    address = address.substring(0, address.length - 2);
  }

  if (address[0] === ',') {
    address = address.substring(2);
  }

  return address;
}

/**
 * Create human-readable file size object
 * @param {Number} size is bytes
 */
export function getFileSize(size = 0) {
  let selectedSize = 0;
  let selectedUnit = 'b';
  const FILE_SIZE_BASE = 1024;

  if (size > 0) {
    const units = ['Тб', 'Гб', 'Мб', 'Кб', 'Б'];
    for (let i = 0, len = units.length; i < len; i++) {
      let unit = units[i];
      let cutoff = Math.pow(FILE_SIZE_BASE, 4 - i) / 10;

      if (size >= cutoff) {
        selectedSize = size / Math.pow(FILE_SIZE_BASE, 4 - i);
        selectedUnit = unit;
        break;
      }
    }
    selectedSize = Math.round(100 * selectedSize) / 100;
  }

  return {
    size: formatNumber(selectedSize),
    units: selectedUnit,
    label: `${selectedSize}${selectedUnit}`,
  };
}

/**
 * Create plural work
 * @param number
 * @param one
 * @param two
 * @param five
 * @returns {*}
 */
export function plural(number, one, two, five) {
  let n = Math.abs(number);
  n %= 100;
  if (n >= 5 && n <= 20) {
    return five;
  }
  n %= 10;
  if (n === 1) {
    return one;
  }
  if (n >= 2 && n <= 4) {
    return two;
  }
  return five;
}

export const formatNumber = (value) => {
  return value !== undefined && value !== null && !Number.isNaN(value)
    ? Number(value).toFixed(2)
    : null;
};

export const formatDate = (date) =>
  moment(date).isValid() ? moment(date).format(DateFormats.long) : null;
